import { SettingOutlined, UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { CommentsDrawer } from 'components/common/table';
import {
  FactoryTable,
  Spacing,
  SpacingUnit,
  SummaryIndicatorsSlider,
} from 'components/ui';
import { useFormReviewFlatTableStore } from 'stores/local';
import { noop } from 'utils/noop';

import { useFormReviewPage } from '../../context';

import { ColumnsSettingsDrawer } from './ColumnsSettingsDrawer';
import s from './Content.module.scss';

const Content: React.FC = () => {
  const { t } = useTranslation();
  const store = useFormReviewFlatTableStore();

  const { setStore, setExtraHeaderButtons, setFormName } = useFormReviewPage();

  React.useEffect(() => {
    setStore(store.formActionsStore);
  }, [setStore, store]);

  React.useEffect(() => {
    const name = store.tableStore.header?.name;
    if (name) {
      setFormName(name);
    }
  }, [setFormName, store.tableStore.header?.name]);

  React.useEffect(() => {
    store.init();
  }, [store]);

  // Устанавливаем кнопки в шапку страницы
  React.useEffect(() => {
    setExtraHeaderButtons(
      <>
        <Button icon={<UploadOutlined />} {...store.exportExcelLink}>
          {t('formReview.exportToExcel')}
        </Button>
        <Button
          onClick={store.columnsSettingsDrawer.drawerState.open}
          icon={<SettingOutlined />}
        >
          {t('formReview.columnsSetup')}
        </Button>
      </>
    );

    return () => {
      setExtraHeaderButtons(null);
    };
  }, [setExtraHeaderButtons, store.exportExcelLink, store.columnsSettingsDrawer.drawerState.open, t]);

  return (
    <Spacing spacing={SpacingUnit.unit4} className={s.content}>
      <SummaryIndicatorsSlider
        fetching={
          store.tableStore.tableAggregationStore.aggregationRequest.loading
        }
        data={store.tableStore.tableAggregationStore.aggregationRow}
      />
      <FactoryTable
        rowClassName={s.content__row}
        rowKey="uniqueId"
        pagination={false}
        expandIcon={noop}
        tableStore={store.tableStore}
        virtual
      />
      <CommentsDrawer commentsStore={store.commentsStore} />
      <ColumnsSettingsDrawer />
    </Spacing>
  );
};

export default observer(Content);
